import { Popover, Select, Space } from "antd";
import React from "react";
import { useTemplate } from "../../utils/Template";
import { EyeOutlined } from '@ant-design/icons';

export default function PresetPicker(props) {

    const { value = null, onChange = () => { }, return_object = false } = props;
    const [template,] = useTemplate();
    const { texts = [] } = template;

    
     // set to default if colour / gradient does not exist in template
     let _value = (template.texts.find(item => item.id === value)) ? value : 0;


    // Intercept change to return either an id or full object
    const handleChange = (_id) => {
        onChange(_id);
    }

    // Draw presets
    const drawPresets = () => {
        return texts.map(item => {
            return (
                <Select.Option key={item.id} value={item.id}>
                    <Space>
                        <Popover placement="left" content={<div className={"bm-txt-" + item.id} >{item.name}</div>}><EyeOutlined /></Popover>
                        {item.name}
                    </Space>
                </Select.Option>
            )
        })
    }

    return (
        <Select value={(_value) ? _value : 0} onChange={(e) => handleChange(e)} style={{ "borderBottom": "1px solid #eee", "width": "100%", "fontSize" : "11px" }} bordered={true}>
            <Select.Option key={0} value={0}>
                <Space>
                    <Popover placement="left" content={<div className={"bm-txt-0"} >No Preset</div>}><EyeOutlined /></Popover>
                    No Preset
                </Space>

            </Select.Option>
            {drawPresets()}
        </Select>
    )
}